;(function () {
  'use strict';

  var mobileMedia = window.matchMedia('(max-width: 798px)');

  function hydrateVideo(video) {
    if (!video || video.dataset.hydrated === 'true') return;

    Array.prototype.forEach.call(video.querySelectorAll('source[data-src]'), function (source) {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });

    video.dataset.hydrated = 'true';
    video.load();
  }

  function getActiveVideo(slide) {
    if (!slide) return null;
    if (mobileMedia.matches) {
      return slide.querySelector('video[data-video-variant="mobile"]') ||
        slide.querySelector('video[data-video-variant="desktop"]');
    }
    return slide.querySelector('video[data-video-variant="desktop"]') ||
      slide.querySelector('video[data-video-variant="mobile"]');
  }

  function initSection(section) {
    if (!section || section.dataset.videoSwiperInitialized === 'true') return;
    section.dataset.videoSwiperInitialized = 'true';

    Array.prototype.forEach.call(section.querySelectorAll('.video-swiper'), function (swiperEl) {
      var paginationEl = swiperEl.querySelector('.pagination');
      var nextEl = swiperEl.querySelector('.next');
      var swiperInstance = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        speed: 300,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        navigation: {
          nextEl: nextEl,
        },
      });

      function pauseAllVideos() {
        Array.prototype.forEach.call(swiperEl.querySelectorAll('video'), function (video) {
          video.pause();
          if (video.dataset.hydrated === 'true') video.currentTime = 0;
        });
      }

      function playCurrentVideo() {
        var currentSlide = swiperInstance.slides[swiperInstance.activeIndex];
        var video = getActiveVideo(currentSlide);
        if (!video) return;

        hydrateVideo(video);
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
        video.onended = function () {
          swiperInstance.slideNext();
        };
      }

      playCurrentVideo();
      swiperInstance.on('slideChange', function () {
        pauseAllVideos();
        window.setTimeout(playCurrentVideo, 300);
      });
    });
  }

  function observeSection(section) {
    if (!section || section.dataset.videoSwiperObserved === 'true') return;
    section.dataset.videoSwiperObserved = 'true';

    if (!('IntersectionObserver' in window)) {
      initSection(section);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        initSection(entry.target);
      });
    }, { rootMargin: '300px 0px' });

    observer.observe(section);
  }

  function observeAll(root) {
    if (root && root.matches && root.matches('.video-container')) observeSection(root);
    Array.prototype.forEach.call((root || document).querySelectorAll('.video-container'), observeSection);
  }

  document.addEventListener('DOMContentLoaded', function () {
    observeAll(document);
    document.addEventListener('shopify:section:load', function (event) {
      observeAll(event.target);
    });
  });
})();
